var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40469 0.895247L9.22156 4.87313L13.2845 5.51088C13.367 5.52191 13.4449 5.55856 13.5091 5.61654C13.5733 5.67452 13.6213 5.75143 13.6473 5.83829C13.6733 5.92515 13.6763 6.01836 13.656 6.10703C13.6356 6.19571 13.5928 6.27617 13.5325 6.33903L10.5946 9.43371L11.2885 13.8062C11.3012 13.8966 11.2908 13.9891 11.2586 14.0734C11.2263 14.1577 11.1734 14.2304 11.1057 14.2835C11.0381 14.3366 10.9583 14.3679 10.8754 14.3739C10.7925 14.38 10.7097 14.3605 10.6363 14.3177L7.00256 12.2531L3.36882 14.3177C3.29538 14.3605 3.21259 14.38 3.12969 14.3739C3.0468 14.3679 2.96706 14.3366 2.8994 14.2835C2.83174 14.2304 2.77881 14.1577 2.74654 14.0734C2.71427 13.9891 2.70393 13.8966 2.71666 13.8062L3.41049 9.43371L0.470575 6.33674C0.410825 6.27363 0.368566 6.19314 0.348708 6.10464C0.32885 6.01613 0.332207 5.92324 0.358391 5.83676C0.384575 5.75027 0.43251 5.67374 0.496626 5.61605C0.560743 5.55837 0.638409 5.5219 0.720603 5.51088L4.78356 4.87313L6.60043 0.895247C6.63842 0.813858 6.69606 0.745575 6.767 0.697899C6.83794 0.650224 6.91945 0.625 7.00256 0.625C7.08567 0.625 7.16718 0.650224 7.23812 0.697899C7.30906 0.745575 7.36669 0.813858 7.40469 0.895247Z",
    fill: "#FFDA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.0515 6.58906C7.71776 6.93317 5.00912 9.20657 4.32363 12.1567H4.31321L4.82577 8.92211L2.64844 6.62806L5.65711 6.15319L7.00309 3.22827L8.34908 6.17154L11.0515 6.58906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarAlt);
export default __webpack_public_path__ + "static/media/star-alt.5e492e4b.svg";
export { ForwardRef as ReactComponent };